import {
  Controller,
  FieldValues,
  Path,
  PathValue,
  useFormContext,
} from "react-hook-form";
import { useLanguage } from "../../Language";
import * as React from "react";
import {
  Checkbox,
  DialogContentText,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Link,
} from "@mui/material";
import { SanitizedHTML } from "../../SanitizedHTML";
import { useDialog } from "@tlc/ui/dialog/useDialog";
import { ConfirmDialog } from "@tlc/ui/dialog/ConfirmDialog";

export interface FormTextFieldProps<T extends FieldValues> {
  name: Path<T>;
  termsAndConditions: string;
}

export const TermsAndConditions = <T extends FieldValues>({
  name,
  termsAndConditions,
}: FormTextFieldProps<T>) => {
  const { translate } = useLanguage();
  const { setValue } = useFormContext<T>();
  const { dialogProps, closeDialog, openDialog } = useDialog();
  return (
    <>
      <ConfirmDialog
        {...dialogProps}
        confirmButtonText={translate("agreeButton")}
        dismissButtonText={translate("close")}
        id="terms-and-conditions"
        headline={translate("termsAndConditions")}
        onConfirm={() => {
          setValue(name, true as PathValue<T, Path<T>>);
          closeDialog();
        }}
      >
        <DialogContentText>
          <SanitizedHTML html={termsAndConditions} />
        </DialogContentText>
      </ConfirmDialog>
      <Controller
        name={name}
        rules={{
          validate: {
            required: (value) =>
              value === true || translate("obrTermsAndConditionsRequired"),
          },
        }}
        render={({
          field: { value, onChange, onBlur, ref },
          fieldState: { error },
        }) => {
          return (
            <FormControl error={!!error}>
              <FormGroup>
                <FormControlLabel
                  inputRef={ref}
                  onBlur={onBlur}
                  required
                  control={
                    <Checkbox
                      checked={value}
                      formNoValidate={true}
                      onChange={onChange}
                    />
                  }
                  label={
                    <>
                      {translate("obrIAgreeToTermsAndConditions")}{" "}
                      <Link
                        component="button"
                        type="button"
                        onClick={openDialog}
                      >
                        {translate("termsAndConditions")}
                      </Link>
                    </>
                  }
                />
              </FormGroup>
              <FormHelperText>{error?.message || " "}</FormHelperText>
            </FormControl>
          );
        }}
      ></Controller>
    </>
  );
};
